<template>
  <div class="gf_notify">
    <Modal
      :break-line="true"
      c-class="gf_notify__modal"
      h-class="bg-hybrid-shade-light-100"
      m-class="gf_notify__modal__body"
      f-class="gf_notify__modal__footer">
      <template #header>
        <div class="gf_notify__modal__header">
          <h2 class="heading-20-medium txt-light-mode-high-contrast">{{ txtHeader }}</h2>
          <div class="gf_notify__modal__header__action">
            <span class="gf_notify__modal__header__action__close" @click="actionNotify('close')"
              ><i class="icon icon-close"></i
            ></span>
          </div>
        </div>
      </template>
      <template #default>
        <div class="gf_notify__modal__body__content">
          <div class="gf_notify__modal__body__content-des paragraph-14-regular" v-html="txtDescription"></div>
          <div
            v-if="txtWarning"
            class="gf_notify__modal__body__content-warning paragraph-14-regular-150"
            v-html="txtWarning"></div>
        </div>
      </template>
      <template #footer>
        <div class="gf_notify__modal__footer__action">
          <button
            class="gf_notify__modal__footer__action__button gf_notify__modal__footer__action__button--cancel button-14-medium"
            @click="actionNotify('cancel')">
            {{ txtButtonCancel }}
          </button>
          <button
            class="gf_notify__modal__footer__action__button gf_notify__modal__footer__action__button--confirm button-14-medium"
            :class="confirmClass"
            @click="actionNotify('confirm')">
            {{ txtButtonConfirm }}
          </button>
        </div>
      </template>
    </Modal>
  </div>
</template>

<script>
export default {
  name: 'NotifyModal',
  props: {
    txtHeader: {
      type: String,
      default: 'Modal',
    },
    txtDescription: {
      type: String,
      default: '',
    },
    txtWarning: {
      type: String,
      default: '',
    },
    txtButtonCancel: { type: String, default: 'Cancel' },
    txtButtonConfirm: { type: String, default: 'Confirm' },
    confirmClass: { type: String, default: '' },
  },
  methods: {
    actionNotify(type) {
      this.$emit('action', type);
    },
  },
};
</script>

<style lang="scss">
@import '@/app/editor/scss/variables';
@import '@/core/themes/vendor/color';
@import '@/core/themes/vendor/variables';
@import '@/core/themes/vendor/mixins';

.gf_notify__modal {
  max-width: 424px;
  .gf_notify__modal__header {
    padding: 24px 32px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    &__action {
      &__close {
        font-size: 16px;
        color: $textLightHigh;
        cursor: pointer;
      }
    }
  }
  .gf_notify__modal__body {
    padding: 24px 32px 0;
    &__content {
      margin-bottom: 24px;
      &-des {
        color: map-get($text-light-mode, 'high-contrast');
      }
      &-warning {
        color: $cYellow3;
        display: flex;
        margin-top: 16px;
        .icon {
          font-size: 18px;
          margin-right: 8px;
          position: relative;
          top: 1px;
          color: map-get($accent-amber-color, '400');
        }
      }
    }
  }
  .gf_notify__modal__footer {
    padding: 24px 32px;
    &__action {
      @include flex-align-center;
      justify-content: flex-end;
      &__button {
        min-height: 40px;
        border-radius: 3px;
        border: 1px solid;
        &--cancel {
          padding: 12px 26px;
          border-color: map-get($hybrid-shade-dark, '300');
          &:hover {
            background: map-get($text-dark-mode, 'high-contrast');
            border: 1px solid map-get($hybrid-shade-dark, '400');
          }
        }
        &--confirm {
          padding: 12px 33px;
          color: map-get($text-dark-mode, 'high-contrast');
          background: map-get($primary-blue-ui-kit, '300');
          border-color: map-get($primary-blue-ui-kit, '300');
          &:hover {
            background: map-get($primary-blue-ui-kit, '325');
            border-color: map-get($primary-blue-ui-kit, '325');
          }
        }
        &:first-child {
          margin-right: 8px;
        }
        &.gf_btn-delete {
          color: map-get($text-dark-mode, 'high-contrast');
          background: map-get($accent-red-ui-kit, '300');
          border-color: map-get($accent-red-ui-kit, '300');
          &:hover {
            background: map-get($accent-red-ui-kit, '400');
            border-color: map-get($accent-red-ui-kit, '400');
          }
        }

        &.gf_btn-primary {
          color: map-get($text-dark-mode, 'high-contrast');
          background: map-get($primary-blue-ui-kit, '300');
          border-color: map-get($primary-blue-ui-kit, '300');
          &:hover {
            background: map-get($primary-blue-ui-kit, '400');
            border-color: map-get($primary-blue-ui-kit, '400');
          }
        }
      }
    }
  }
}
</style>
